import { AccessController } from '@adornis/abac/core/AccessController.js';
import { ContractsPolicy } from '../../contracts/ContractsPolicy.js';
import { MartinusTemporaryPolicy } from '../../MartinusTemporaryPolicy.js';
import { SepaMandatePolicy } from '../../sepa/SepaMandatePolicy.js';
import { UserDetailsPolicy } from '../../users/details/UserDetailsPolicy.js';
import { UserEmployeeDetailsPolicy } from '../../users/employees/UserEmployeeDetailsPolicy.js';
import { UserListPolicy } from '../../users/list/UserListPolicy.js';
import { UserProfilePolicy } from '../../users/profile/UserProfilePolicy.js';
import { type UserOnUserPayload, UserPolicy } from '../../users/UserPolicy.js';
import type { MartinusAbacPayload } from '../abac-payloads/MartinusAbacPayload.js';
import { AdminPolicy } from '../policies/AdminPolicy.js';

// TODO typing in engine
export const MartinusAccessController = new AccessController<MartinusAbacPayload | UserOnUserPayload>({
  policies: [
    AdminPolicy,
    UserListPolicy,
    UserPolicy,
    UserProfilePolicy,
    UserDetailsPolicy,
    UserEmployeeDetailsPolicy,
    ContractsPolicy,
    SepaMandatePolicy,
    MartinusTemporaryPolicy,
  ],
});
